import React from "react";
import { Download, Share2 } from "lucide-react";
import { API } from "@/lib/api";

const NETS = [
  { id: "x", label: "X", href: (u, t) => `https://twitter.com/intent/tweet?text=${t}&url=${u}` },
  { id: "facebook", label: "Facebook", href: (u) => `https://www.facebook.com/sharer/sharer.php?u=${u}` },
  { id: "whatsapp", label: "WhatsApp", href: (u, t) => `https://wa.me/?text=${t}%20${u}` },
];

export default function ChampionShare({ slug, champion, name }) {
  const card = `${API}/tournaments/${slug}/champion-card.png`;
  const page = encodeURIComponent(`${window.location.origin}/tournaments/${slug}`);
  const text = encodeURIComponent(`${champion} are the champions of ${name}!`);
  return (
    <div className="mt-6 flex flex-col sm:flex-row gap-5 items-start" data-testid="champion-share">
      <a href={card} target="_blank" rel="noreferrer" className="shrink-0 group">
        <img src={card} alt={`${champion} champion card`} loading="lazy" data-testid="champion-card-img"
          className="w-36 h-36 rounded-xl border border-white/10 object-cover transition-transform duration-300 group-hover:scale-[1.03]" />
      </a>
      <div className="min-w-0">
        <div className="text-sm font-semibold text-white flex items-center gap-2"><Share2 size={14} className="text-yellow-400" /> Share the champion card</div>
        <p className="text-xs text-white/50 mt-1">1080×1080 image, ready for Instagram, X, Facebook and WhatsApp.</p>
        <div className="mt-3 flex flex-wrap gap-2">
          <a href={`${card}?download=1`} download={`${slug}-champion.png`} data-testid="champion-card-download"
            className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 text-black text-xs font-bold px-4 py-2 transition-transform hover:-translate-y-0.5">
            <Download size={13} /> Download PNG
          </a>
          {NETS.map((n) => (
            <a key={n.id} href={n.href(page, text)} target="_blank" rel="noreferrer" data-testid={`champion-share-${n.id}`}
              className="inline-flex items-center rounded-full border border-white/15 text-white/80 text-xs font-semibold px-4 py-2 transition-colors hover:bg-white/10 hover:text-white">
              {n.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
